import React from 'react';
import { Button } from './ui/button';
import { cn } from '../lib/utils';

export function PreliminarySection({ marked, sectionName, toggleSectionPreliminary }) {
  const name = sectionName || 'whole section';
  const text = marked
    ? `Unmark this ${name} as preliminary`
    : `Mark this ${name} as preliminary`;

  return (
    <div className={cn(
      "my-4 rounded-xl border p-4 text-center",
      // "Preliminary" is a provisional state, not an error — the design system
      // reserves danger for errors, so it reads on the info (LCSB Sky) surface.
      marked
        ? "border-info-900 bg-info-50"
        : "border-primary-900 bg-primary-50"
    )}>
      <Button
        id="preliminary-section-button"
        title="section preliminary"
        variant={marked ? "outline" : "default"}
        onClick={toggleSectionPreliminary}
      >
        {text}
      </Button>
    </div>
  );
}
